export enum LockType {
    QUESTION = 1,
    MEASURE = 2
}
